import React, { useEffect, useState } from 'react';

import CButton from '../button/button';
import CInput from '../input/input';
import { Line, Space } from '../utils/utils';

import '../../theme/global.scss';
import { INewMeasure } from '../../utils/interfaces/interfaces';
import { addMeasure } from '../../network/measure';
import { notify } from '../../notifications/notification';
import { capitalizeFirstLetter, formatDate } from '../../utils/strings';
import { measuresTypes, TMeasure } from '../../types/measures';
import { validateMeasure } from '../../utils/validators';
import CChip from '../chip/chip';

interface IMeasure {
  callback?: () => void;
  idMonitorization: number;
  type: TMeasure;
}

const initialState: INewMeasure = {
  number: '',
  responsiblePerson: '',
  originalDeadline: new Date(),
  decisionId: 0,
  description: '',
  observations: ''
};

const AddMeasure = (props: IMeasure) => {
  const [form, updateForm] = useState(initialState);
  const [responsibles, setResponsibles] = useState([] as string[]);
  const [responsibleInput, setInput] = useState('');

  useEffect(() => {
    updateForm(form => ({ ...form, decisionId: props.idMonitorization }));
  }, [props.idMonitorization]);

  useEffect(() => {
    updateForm(form => ({
      ...form,
      responsiblePerson: responsibles.join(', ')
    }));
  }, [responsibles]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = event.target;
    updateForm(form => ({ ...form, [name]: value }));
  };

  const handleDate = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    new Date(value)
      ? updateForm(form => ({ ...form, originalDeadline: new Date(value) }))
      : updateForm(form => ({ ...form, originalDeadline: new Date() }));
  };

  const handleSubmit = (event: React.MouseEvent) => {
    /* prevent from reloading */
    event.preventDefault();
    if (responsibles.length === 0 && responsibleInput.length > 0) {
      updateForm(form => ({
        ...form,
        responsiblePerson: responsibleInput
      }));
    }
    if (validateMeasure(form)) {
      /* submit request */
      addMeasure({ ...form }).then(() => {
        notify('Ați adăugat o măsură.', 'success');
        if (props.callback) props.callback();
      });
    }
  };

  const removeResposible = (person: string) => {
    const filtered = responsibles.filter(entry => entry !== person);
    setResponsibles(filtered);
  };

  const addResponsible = () => {
    if (responsibleInput.length > 0) {
      setResponsibles(responsibles =>
        responsibles.concat([capitalizeFirstLetter(responsibleInput)])
      );
      setInput('');
    } else {
      notify('Nu ați introdus un nume.', 'warning');
    }
  };

  return (
    <form>
      <p className='body-dark bold'>
        Adăugare{' '}
        {props.type === measuresTypes.MEASURES ? 'măsură' : 'recomandare'}
      </p>
      <Line width={'80px'} />
      <Space vertical={'30px'} />
      <CInput
        label='Număr'
        type='number'
        id='number'
        placeholder='Număr'
        name='number'
        value={form.number}
        onChange={handleChange}
        required
      />
      <CInput
        label={
          props.type === measuresTypes.MEASURES ? 'Măsura' : 'Recomandarea'
        }
        type='text'
        id='masura'
        placeholder='Descriere'
        name='description'
        value={form.description}
        onChange={handleChange}
        required
      />
      <CInput
        label='Termen de realizare'
        type='date'
        id='date'
        placeholder='data'
        name='data'
        value={formatDate(form.originalDeadline)}
        onChange={handleDate}
        required
      />
      {/* <CInput
        label='Termen prelungit'
        type='text'
        id='deadline'
        placeholder='Nu puteți completă acest câmp acum'
        name='deadline'
        // value={form.deadline}
        onChange={handleChange}
        required
        disabled
      /> */}
      <div className='inputWithButton'>
        <CInput
          label='Responsabili'
          type='text'
          id='responsabil'
          placeholder='Nume Prenume'
          name='responsibleInput'
          value={responsibleInput}
          onChange={e => setInput(e.target.value)}
          required
        />
        <CButton label='+' onClick={addResponsible} type='button' />
      </div>

      {responsibles.length > 0 && (
        <div className='justify-start wrap h-padding fullWidth'>
          {responsibles.map((responsible: string, index: number) => (
            <CChip
              key={index}
              label={responsible}
              removable
              onRemove={removeResposible}
            />
          ))}
        </div>
      )}
      <Space vertical={'30px'} />
      <p className='info h-padding'>
        Pentru a introduce mai mulți responsabili, vă rugăm, apăsați butonul
        după fiecare responsabil.
      </p>
      <Space vertical={'30px'} />
      <CButton label='Adaugă' type='submit' onClick={handleSubmit} />
    </form>
  );
};

export default AddMeasure;
